module.exports = "<div class=\"q-marg-top-sm hs-code-missing\"> <div class=\"q-alert q-alert-red\"> This SKU is <span class=q-boldest>missing the HS Code and/or the Country of Origin</span> and cannot be shipped internationally. Please add this information to the product, or remove this SKU to continue editing. </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/order/html/missingCodeError.html
// module id = 1362
// module chunks = 1